/* ==========================================
   ORIGINS FAMILY FOODS - CUSTOM JS
   ========================================== */

// Announcement Bar Rotation
(function() {
  const slider = document.querySelector('[data-announcement-slider]');
  if (!slider) return;

  const slides = slider.querySelectorAll('.announcement-bar__slide');
  if (slides.length <= 1) return;

  let current = 0;
  const bar = slider.closest('.announcement-bar');
  const speed = parseInt(bar.dataset.rotationSpeed || '5') * 1000;

  // Hide all but first
  slides.forEach(function(s, i) {
    s.style.display = i === 0 ? 'block' : 'none';
    s.style.opacity = i === 0 ? '1' : '0';
    s.style.transition = 'opacity 0.4s ease';
  });

  setInterval(function() {
    slides[current].style.opacity = '0';
    setTimeout(function() {
      slides[current].style.display = 'none';
      current = (current + 1) % slides.length;
      slides[current].style.display = 'block';
      requestAnimationFrame(function() {
        slides[current].style.opacity = '1';
      });
    }, 400);
  }, speed);

  // Dismiss button
  var dismiss = document.querySelector('[data-announcement-dismiss]');
  if (dismiss) {
    dismiss.addEventListener('click', function() {
      bar.style.display = 'none';
      try { sessionStorage.setItem('announcement-dismissed', 'true'); } catch(e) {}
    });
  }

  // Check if previously dismissed
  try {
    if (sessionStorage.getItem('announcement-dismissed') === 'true') {
      bar.style.display = 'none';
    }
  } catch(e) {}
})();
